import { motion } from "framer-motion";
import { PILLARS, MENTORSHIP_BG } from "@/lib/content";
import Tilt3D from "@/components/site/Tilt3D";

const fade = {
  initial: { opacity: 0, y: 18 },
  whileInView: { opacity: 1, y: 0 },
  transition: { duration: 0.9, ease: [0.16, 1, 0.3, 1] },
  viewport: { once: true, margin: "-80px" },
};

export default function Pillars() {
  return (
    <section id="approach" data-testid="pillars-section" className="relative border-t border-hairline overflow-hidden">
      <div
        aria-hidden
        className="absolute inset-0 opacity-[0.07]"
        style={{
          backgroundImage: `url(${MENTORSHIP_BG})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />
      <div className="relative max-w-7xl mx-auto px-6 lg:px-8 py-28 lg:py-40">
        <motion.div {...fade} className="max-w-3xl">
          <span className="overline" data-testid="pillars-overline">The Approach</span>
          <h2 className="font-serif text-4xl md:text-6xl font-medium leading-[0.95] tracking-tight mt-6">
            Four pillars.
            <br />
            <span className="italic font-light text-platinum">One operator.</span>
          </h2>
          <p className="font-sans text-sand text-base md:text-lg leading-relaxed mt-8">
            Every mentorship is bespoke, but it is built on the same four foundations.
            Strategy without these collapses. Strategy on top of these compounds.
          </p>
        </motion.div>

        <div className="mt-24 grid grid-cols-1 md:grid-cols-2 gap-x-16 gap-y-20">
          {PILLARS.map((p, i) => (
            <motion.article
              key={p.n}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1], delay: i * 0.08 }}
              viewport={{ once: true, margin: "-80px" }}
              data-testid={`pillar-${p.n}`}
              className="border-t border-hairline pt-10"
            >
              <Tilt3D maxTilt={4} className="will-change-transform">
                <div className="flex items-start gap-8" style={{ transform: "translateZ(0)" }}>
                  <div className="editorial-num text-5xl md:text-6xl text-smoke">{p.n}</div>
                  <div>
                    <h3 className="font-serif text-2xl md:text-3xl text-bone">{p.title}</h3>
                    <p className="mt-5 font-sans text-sand text-base leading-relaxed max-w-md">
                      {p.body}
                    </p>
                  </div>
                </div>
              </Tilt3D>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
